import { persistor } from "./redux/rootReducer";

import { PersistGate } from "redux-persist/integration/react";
import { LoaderComponent } from "./auth/PrivateRoute";
import AuthRouter from "./auth/AuthRouter";
import { IntlProvider } from "react-intl";
import AppLocale from "./common/lang";
import { CssBaseline } from "@mui/material";
import OverlaySpinner from "./component/loader/OverlaySpinner";
import { WebsocketProvider } from "./context/websocket";
import AxiosInterceptor from "./context/axiosinstance";
import { SnackbarProvider } from "notistack";
import { ErrorHandlerProvider } from "./context/ErrorBoundary";
import { ErrorPopup } from "./component/modal/ErrorPopup";
import { ThemeModeProvider } from "context/ThemeContaxt/ThemeModeContext";

const App = () => {
  const currentAppLocale = AppLocale.en;

  return (
      <SnackbarProvider> {/* Future to remove for the this because we are using toast tailwindcss */}
      <ThemeModeProvider>
        <CssBaseline />
        <OverlaySpinner />
        <PersistGate loading={<LoaderComponent />} persistor={persistor}>
          <WebsocketProvider>
            <ErrorHandlerProvider>
              <AxiosInterceptor>
                  <ErrorPopup />
                  <IntlProvider
                    locale={currentAppLocale.locale}
                    messages={currentAppLocale.messages}
                    >
                      <AuthRouter />  
                  </IntlProvider>
              </AxiosInterceptor>
            </ErrorHandlerProvider>
          </WebsocketProvider>
        </PersistGate>
      </ThemeModeProvider>
    </SnackbarProvider>
  );
};

export default App;
